import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL } from '../../../config';
import deviceInfoAxios from '../../../utils/axios/deviceInfo.axios';

const tryToFetchReports = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: string,
): Promise<AxiosResponse<any>> => {
    const url = filters
        ? `${DEVICE_INFO_API_URL}/rebecca-reports?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${DEVICE_INFO_API_URL}/rebecca-reports?page=${pageNumber}&size=${pageSize}`;
    return deviceInfoAxios.put<any>(url, data);
};

const tryToFetchQualityReport = (data: any): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/rebecca-ai-agent/feedback-chats/service-quality-report`
    return deviceInfoAxios.put(url, data);
};

const tryToFetchSingleReport = (id: string): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/rebecca-reports/${id}`
    return deviceInfoAxios.get(url);
};

const tryToFetchTripTopics = (): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/rebecca-ai-agent/rebecca-feedback/topics`
    return deviceInfoAxios.get(url);
};

const tryToSignoffReport = (data: any): Promise<AxiosResponse<any>> => {
    return deviceInfoAxios.post(`${DEVICE_INFO_API_URL}/rebecca-reports/signoff`, data);
};

const tryToDownloadTrainManagerReport = (tripId: string, lang: string = 'en'): Promise<AxiosResponse<any>> => {
    const url = `${DEVICE_INFO_API_URL}/journey-reports/export/${tripId}/pdf-html?lang=${lang}`;
    return deviceInfoAxios.post(url, {});
};

export const ReportsService = {
    tryToFetchReports,
    tryToFetchSingleReport,
    tryToSignoffReport,
    tryToFetchQualityReport,
    tryToFetchTripTopics,
    tryToDownloadTrainManagerReport
};